import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import * as qs from 'querystringify';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { SHARED_FOLDER_ID, VAGUE_ROOT_ID } from "../common/list-query";
import { requestV1Cgi, RetCode } from "../data-source/network-request";
import { DEFAULT_DOMAIN_ID } from "../model/drive-file";
/**
 * 置顶.
 */
export var PinRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(PinRequest, _DriveRequest);
  var _super = _createSuper(PinRequest);
  function PinRequest() {
    _classCallCheck(this, PinRequest);
    return _super.apply(this, arguments);
  }
  _createClass(PinRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: '/cgi-bin/online_docs/doc_pin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
          domain_id: DEFAULT_DOMAIN_ID,
          pad_id: params.id,
          list_type: params.folderId === SHARED_FOLDER_ID ? 4 : 2,
          folder_id: params.folderId === SHARED_FOLDER_ID ? VAGUE_ROOT_ID : params.folderId,
          version: 2,
          xsrf: getXsrfToken()
        })
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'PinResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
    }
  }]);
  return PinRequest;
}(DriveRequest);

/**
 * 取消置顶.
 */
export var UnpinRequest = /*#__PURE__*/function (_DriveRequest2) {
  _inherits(UnpinRequest, _DriveRequest2);
  var _super2 = _createSuper(UnpinRequest);
  function UnpinRequest() {
    _classCallCheck(this, UnpinRequest);
    return _super2.apply(this, arguments);
  }
  _createClass(UnpinRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: '/cgi-bin/online_docs/doc_unpin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
          domain_id: DEFAULT_DOMAIN_ID,
          pad_id: params.id,
          list_type: params.folderId === SHARED_FOLDER_ID ? 4 : 2,
          folder_id: params.folderId === SHARED_FOLDER_ID ? VAGUE_ROOT_ID : params.folderId,
          version: 2,
          xsrf: getXsrfToken()
        })
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'UnpinResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
    }
  }]);
  return UnpinRequest;
}(DriveRequest);
//# sourceMappingURL=pin.js.map